import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface TransitProps {
  id: string;
  approveRevisions: boolean;
}

export const useReleaseTransit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, approveRevisions }: TransitProps) => {
      const result = await apiClient.transit.requestRelease.mutation({ body: { transitId: id, approveRevisions } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      queryClient.invalidateQueries({ queryKey: ['transit', variables.id] });
      toast.success(`Release request was sent!`);
    },
    onError: (error) => {
      showErrorToast(error, `Error sending the release request!`);
    },
  });
};
